import { TranslateService } from '@ngx-translate/core';
import { DetailsService } from 'app/components/details/details.service';
import { Component, OnInit, Input } from '@angular/core';
import { RolesService } from 'app/components/roles/roles.service';
import { CONSTANTS } from 'environments/common';
import { Router, ActivatedRoute } from '@angular/router';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { SessionService } from 'app/components/common/session/session.service';
import { UtilsService } from '../utils/utils.service';

@Component({
  selector: 'app-edition-panel',
  templateUrl: './edition-panel.component.html',
  styleUrls: ['./edition-panel.component.css']
})
export class EditionPanelComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  roles: object = CONSTANTS.ROLES;

  @Input() hidesEditItem: boolean = false;
  updateItem: boolean = false;


  editableLiterals: Array<any> = [
    {
      property: 'exhibitors',
    },
    {
      property: 'products',
    },
    {
      property: 'novelties',
    },
    {
      property: 'brands',
    },
    {
      property: 'title.favorites',
    },
    {
      property: 'filters',
    },
    {
      property: 'categories',
    },
    {
      property: 'additional_categories',
    },
    {
      property: 'countries',
    },
    {
      property: 'sectors',
    },
    {
      property: 'active_filters',
    },
    {
      property: 'sponsored',
    },
    {
      property: 'sponsored5',
    },
    {
      property: 'sponsored6',
    },
    {
      property: 'featured2'
    }
  ];

  editableDetails: Array<string> = [
    'colors.mainColor',
    'colors.color',
    'colors.headerColor',
    'colors.languageColor',
    'colors.pageColor',
    'colors.featuredColor',
    'colors.featuredTextColor',
    'colors.sponsoredTextColor',
    'colors.sponsoredColor',
    'colors.favorite',
    'colors.favorite-empty',
    'colors.pagination.default',
    "filter.hierarchicalProperties.active",
    "filter.countries.active",
    "filter.sectors.active",
    "filter.properties.active",
    "filter.hierarchicalProperties.sort",
    "filter.masterProperties.sort",
    'social.share.facebook',
    'social.share.twitter',
    'social.share.linkedIn',
    'social.share.pinterest',
    'social.share.telegram',
    'social.share.whatsApp',
    'social.share.googlePlus',
    'social.share.messenger',
    'social.share.instagram',
    'social.share.tiktok',
    'social.share.youtube',
    'colors.facebook',
    'colors.flickr',
    'colors.google_plus',
    'colors.instagram',
    'colors.linkedin',
    'colors.messenger',
    'colors.pinterest',
    'colors.telegram',
    'colors.twitter',
    'colors.whatsapp'
  ];

  hidesLiterals: boolean = true;
  hidesDetails: boolean = true;

  detailType = {
    STRING: "STRING",
    INT: "INT",
    BOOLEAN: "BOOLEAN"
  }
  detailProperty = {
    EMPTY: "EMPTY",
    FILTER: "FILTER",
    COLOR: "COLOR"
  }
  detailGroup = {
    EMPTY: "EMPTY",
    INITIAL: "INITIAL",
    GLOBAL: "GLOBAL",
    COLOR_CATALOGUE: "COLOR_CATALOGUE",
    ORDER_UNIFIED_SEARCH: "ORDER_UNIFIED_SEARCH"
  }

  editableDetailsPrepared:Array<any> = [];

  languages: Array<any> = [];

  @Input() catalogueId;
  eventName;
  @Input() exhibitorId;
  productId;

  eventData: object = {};

  constructor(public rolesService: RolesService, private router: Router, public catalogueService: CatalogueService, private sessionService: SessionService,
    private detailsService:DetailsService, private activatedRoute: ActivatedRoute, private utilsService: UtilsService, private translateService:TranslateService
  ) {
    this.catalogueId = this.activatedRoute.snapshot.paramMap.get('catalogueId') || this.catalogueId;
    this.eventName = this.activatedRoute.snapshot.paramMap.get('event') || null;
    this.exhibitorId = this.activatedRoute.snapshot.paramMap.get('id') || this.exhibitorId;
    this.productId = this.activatedRoute.snapshot.paramMap.get('productId') || null;
  }

  showEdit() {

    if (this.rolesService.hasRoles([this.roles['BACKOFFICE'], this.roles['MULTIEXHIBITOR'], this.roles['SUPERADMIN']])) {
      return true;
    } else if (this.rolesService.exhibitorCanEdit(this.exhibitorId)) {
      return true;
    } else {
      return false;
    }

  }

  isAdmin() {

    if (this.rolesService.hasRoles([this.roles['BACKOFFICE'], this.roles['SUPERADMIN']])) {
      return true;
    } else {
      return false;
    }

  }

  toggleItem(item) {

  }

  goToEdit() {

    let url = '';

    if (!this.productId) {
      url = this.catalogueId + '/' + this.eventName + '/exhibitor-backoffice/exhibitors/' + this.exhibitorId + '/edit';
    } else {
      url = this.catalogueId + '/' + this.eventName + '/exhibitor-backoffice/exhibitors/' + this.exhibitorId + '/products/' + this.productId + '/product-detail-edit';
    }

    this.router.navigate([url]);

  }


  getCatalogueLanguageProperties(getCatalogueLanguagePropertiesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.getCatalogueLanguageProperties(getCatalogueLanguagePropertiesIn)
      .subscribe((data: object) => {
        this.getCatalogueLanguagePropertiesOk(data);
      },
        error => {
          this.getCatalogueLanguagePropertiesError(error);
        });

  }

  getCatalogueLanguagePropertiesOk(data) {

    this.loader.count--;

    if(this.areAllPropertiesPresent(this.editableLiterals, data)){

      this.updateItem = true;

      for (const property in data) {
  
        for(let i = 0; i < this.editableLiterals.length; i++) {
  
          if (property === this.editableLiterals[i].property) {
  
            let translationsMap = data[property]['translationsMap'];
            this.editableLiterals[i].translationsMap = this.editableLiterals[i].translationsMap || [];
            this.editableLiterals[i]['id'] = data[property]['id'];
  
            for (const language in translationsMap) {
              this.editableLiterals[i].translationsMap.push(translationsMap[language]);
            }
  
          }
  
        }
  
      }
    }
    else
      this.executeGenerateLiterals();
      

  }

  getCatalogueLanguagePropertiesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

    this.executeGenerateLiterals();

  }

  saveLiteralsBtn() {

    let catalogueLanguageSaveAndUpdateIn = {
      literals: this.prepareLiterals(this.editableLiterals),
      catalogueId: this.catalogueId
    }

    this.catalogueLanguageSaveAndUpdate(catalogueLanguageSaveAndUpdateIn);

  }

  prepareLiterals(literals) {

    let translationsMap: Array<any> = [];

    for (let i = 0; i < literals.length; i++) {

      let property: object = {
        id: literals[i]['id'],
        property: literals[i]['property'],
        translationsMap: {}
      };

      let translation: object = {};

      for (let j = 0; j < literals[i].translationsMap.length; j++) {
        let lang = literals[i].translationsMap[j];
        translation[lang['language']] = lang;
      }

      property['translationsMap'] = translation;
      translationsMap.push(property);

    }

    return translationsMap;

  }

  catalogueLanguageSaveAndUpdate(catalogueLanguageSaveAndUpdateIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.catalogueLanguageSaveAndUpdate(catalogueLanguageSaveAndUpdateIn)
      .subscribe((data: object) => {
        this.catalogueLanguageSaveAndUpdateOk(data);
      },
        error => {
          this.catalogueLanguageSaveAndUpdateError(error);
        });

  }

  catalogueLanguageSaveAndUpdateOk(data) {
    this.loader.count--;
    window.location.reload();
  }

  catalogueLanguageSaveAndUpdateError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  setProperties() {
    this.editableDetailsPrepared = [];
    const autoDetect = (data:any) => {
      switch (typeof(data)) {
        case "boolean":
          return this.detailType.BOOLEAN;
        case "number":
          return this.detailType.INT;
        default:
          return this.detailType.STRING;
      }
    };
    const getProp = (data:any) => {
      switch(data.split(".")[0]) {
        case "colors":
          return this.detailProperty.COLOR;
        case "filters":
          return this.detailProperty.FILTER;
        default:
          return this.detailProperty.EMPTY;
      }
    };
    Object.keys(this.editableDetails).forEach(key => {
      if (!this.editableDetails[key].includes('googlePlus') && !this.editableDetails[key].includes('messenger')) {
        this.editableDetailsPrepared.push({detailKey: this.editableDetails[key], detailType:autoDetect(getProp(this.editableDetails[key])),
          detailValue: this.getDetailProperty(this.editableDetails[key], getProp(this.editableDetails[key])),
          description: '', modified: false, detailProperty: getProp(this.editableDetails[key]), fixed: true,
          detailGroup: this.detailGroup.EMPTY});
      }
    });
  }

  getDetailProperty(key:string, type:string):any {
    return this.detailsService.getPropertyByKey(key, (type === 'EMPTY'));
  }

  saveFile(saveFileIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.saveFile(saveFileIn)
      .subscribe((data: object) => {
        this.saveFileOk(data);
      },
        error => {
          this.saveFileError(error);
        });

  }

  saveFileOk(data) {
    this.loader.count--;

    this.executeDetails();
  }

  saveFileError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  saveDetails(details:Array<any>) {

    Promise.all(details.map(detail =>
      new Promise((s,r) => {

        let getCatalogueDetailIdIn = {
          catalogueId: this.catalogueId,
          detailKey: detail.detailKey
        }

        this.detailsService.getCatalogueDetailId(getCatalogueDetailIdIn).subscribe(res => {
          detail.id = Object.keys(res)[0];
          s(true);
        }, (err => {
          s(false);

          let createCatalogueDetailsIn = {
            catalogueId: this.catalogueId,
            catalogueDetails: detail
          }

          this.createCatalogueDetails(createCatalogueDetailsIn);

        }));
      })
    )).then(res => {

      let editableDetailsList = {};
      details.forEach((detail, idx) => editableDetailsList[detail.id || idx] = detail);

      let updateCatalogueDetailsIn = {
        catalogueId: this.catalogueId,
        catalogueDetails: editableDetailsList
      }

      this.updateCatalogueDetails(updateCatalogueDetailsIn);

    }).catch(err => {
      console.warn('err', err);
    });

  }

  updateImagesColorsBanner(updateImagesColorsBannerIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.updateImagesColorsBanner(updateImagesColorsBannerIn)
      .subscribe((data: object) => {
          this.updateImagesColorsBannerOk(data);
        },
        error => {
          this.updateImagesColorsBannerError(error);
        });

  }

  updateImagesColorsBannerOk(data) {
    this.loader.count--;
  }

  updateImagesColorsBannerError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  updateCatalogueDetails(updateCatalogueDetailsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.detailsService.updateCatalogueDetails(updateCatalogueDetailsIn)
      .subscribe((data: object) => {
        this.updateCatalogueDetailsOk(data, updateCatalogueDetailsIn.catalogueDetails);
      },
        error => {
          this.updateCatalogueDetailsError(error);
        });

  }

  updateCatalogueDetailsOk(data, catalogueDetails) {

    this.loader.count--;

    let saveFileIn = {
      catalogueId: this.catalogueId
    }

    this.saveFile(saveFileIn);

    this.updateImageAndColors(catalogueDetails);

  }

  private updateImageAndColors(catalogueDetails) {

    let dataPost = {
      "eventName": this.eventName,
      "mainColor": '',
      "headerColor": '',
      "languageColor": '',
      "pageColor": '',
      "sponsoredColor": '',
      "featuredColor": '',
      "templateType": "DEFAULT",
      "imageLogo": this.eventData['imageLogo'],
      "imageBackground": this.eventData['imageBackground']
    };
    const validKeys = Object.keys(dataPost);

    Object.values(catalogueDetails).forEach((entry: any) => {
      if (entry.detailKey.startsWith('colors.')) {
        const propertyName = entry.detailKey.replace('colors.', '');

        if (validKeys.includes(propertyName)) {
          dataPost[propertyName] = entry.detailValue;
          if (this.eventData[propertyName]) {
            this.eventData[propertyName] = entry.detailValue;
          }
        }
      }
    });
    this.catalogueService.setData(this.eventData);

    let dataUpdateImagesColorsBanner = {
      language: this.translateService.currentLang,
      dataPost: dataPost
    }

    this.updateImagesColorsBanner(dataUpdateImagesColorsBanner);
  }

  updateCatalogueDetailsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  createCatalogueDetails(createCatalogueDetailsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.detailsService.createCatalogueDetails(createCatalogueDetailsIn)
      .subscribe((data: object) => {
        this.createCatalogueDetailsOk(data);
      },
        error => {
          this.createCatalogueDetailsError(error);
        });

  }

  createCatalogueDetailsOk(data) {
    this.loader.count--;
  }

  createCatalogueDetailsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  executeDetails() {
    let getDetailsJsonIn = {
      sapCode: this.catalogueService.getProperty('sapCode')
    };
    this.getDetailsJson(getDetailsJsonIn);
    this.getDetailsJson(getDetailsJsonIn, true);
  }

  

  getDetailsJson(getDetailsJsonIn, local = false) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.detailsService.getDetailsJson(getDetailsJsonIn, local)
      .subscribe((data: object) => {
        this.getDetailsJsonOk(data, local);
      },
        error => {
          this.getDetailsJsonError(error);
        });

  }

  getDetailsJsonOk(data, local) {

    this.loader.count--;
    this.detailsService.setDetailsJson(data, local);
    this.detailsService.setIsUpdateDetails(true);

  }

  getDetailsJsonError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
    this.detailsService.setIsUpdateDetails(true);

  }

  
  async executeGenerateLiterals(): Promise<void> {
    await this.generateLiterals();

    let updatePropertiesIn = {
      catalogueId: this.catalogueService.getProperty('id'),
      language: this.translateService.currentLang,
      dataPut: this.editableLiterals
    }

    this.updateProperties(updatePropertiesIn);
  }

  async generateLiterals(){
    
    const currentLang = this.translateService.currentLang; // Idioma actual

    for (let i = 0; i < this.editableLiterals.length; i++) {
      const data = {
        translationsMap: {},
        property: this.editableLiterals[i].property,
      };

      // Iterar sobre los idiomas
      for (const langKey of Object.keys(this.languages)) {
        const lang = this.languages[langKey];
        const longLang = this.utilsService.mapLanguageCode(lang);

        // Cambiar el idioma y esperar a que se cargue
        await this.translateService.use(lang).toPromise();

        // Obtener la traducción usando el idioma cargado
        const translationKey = `EDITION_PANEL.LITERALS.${data.property}`;
        const translation = this.translateService.instant(translationKey);

        // Construir el objeto de traducción
        data.translationsMap[longLang] = {
          id: langKey,
          name: translation,
          language: longLang,
        };
      }

      // Restaurar el idioma original después de procesar los idiomas
      await this.translateService.use(currentLang).toPromise();

      // Actualizar la lista editable
      this.editableLiterals[i] = data;
      
    }
      
  }

  updateProperties(updatePropertiessIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';
    
    this.catalogueService.updateProperties(updatePropertiessIn)
      .subscribe((data: object) => {
        this.updatePropertiesOk(data);
      },
        error => {
          this.updatePropertiesError(error);
        });
    
  }

  updatePropertiesOk(data) {

    this.loader.count--;

    this.editableLiterals = [
      {
        property: 'exhibitors',
      },
      {
        property: 'products',
      },
      {
        property: 'novelties',
      },
      {
        property: 'brands',
      },
      {
        property: 'title.favorites',
      },
      {
        property: 'filters',
      },
      {
        property: 'categories',
      },
      {
        property: 'additional_categories',
      },
      {
        property: 'countries',
      },
      {
        property: 'sectors',
      },
      {
        property: 'active_filters',
      },
      {
        property: 'sponsored',
      },
      {
        property: 'sponsored5',
      },
      {
        property: 'sponsored6',
      },
      {
        property: 'featured2'
      }
    ];

    this.updateItem = true;

    for (const property in data) {

      for(let i = 0; i < this.editableLiterals.length; i++) {

        if (property === this.editableLiterals[i].property) {

          let translationsMap = data[property]['translationsMap'];
          this.editableLiterals[i].translationsMap = this.editableLiterals[i].translationsMap || [];
          this.editableLiterals[i]['id'] = data[property]['id'];

          for (const language in translationsMap) {
            this.editableLiterals[i].translationsMap.push(translationsMap[language]);
          }

        }

      }

    }

  }

  updatePropertiesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  areAllPropertiesPresent(
    editableLiterals: Array<{ property: string }>,
    translations: Record<string, any>
  ): boolean {
    let bndExists = true;
    // Iterar por cada literal y verificar si su propiedad existe en el objeto de traducciones
    for (let index = 0; index < editableLiterals.length; index++) {
      const literal = editableLiterals[index];
      if (!translations[literal.property]) {
        bndExists = false;
      }
      else {
        editableLiterals.splice(index, 1);
      }
    }
  
    // Si no falta ninguna propiedad, retornar true
    return bndExists;
  }


  ngOnInit() {

    let getCatalogueLanguagePropertiesIn = {
      catalogueId: this.catalogueId
    }

    this.getCatalogueLanguageProperties(getCatalogueLanguagePropertiesIn);

    this.languages = JSON.parse(this.sessionService.get('availableLanguages', false));

    this.detailsService.getIsUpdateDetails().subscribe(update => {
      if(update)
        this.setProperties();//INFO Se dispara si tiene datos o da error la llamada que te trae los detalles
    });

    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');

  }

}
